// SEPA mandates for debtors outside the EEA require a full billing address,
// which the donation form does not collect, so we reject those IBANs outright.
// We have only CH, because other all other countries are excluded in Stripe
const NON_EEA_COUNTRIES = ['CH']

function isNonEeaIbanCountry(country?: string) {
  return !!country && NON_EEA_COUNTRIES.includes(country)
}

export default isNonEeaIbanCountry
